import React, { Component } from 'react'

import { Input, Button, TextArea, Select } from '@driftt/tide'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  createSection,
  changeSectionName,
  changeSectionDescription,
  changeSectionCategory
} from 'modules/knowledgebase/actions'

import { getSectionToEdit, getCategories, getSelectedCategoryId } from 'modules/knowledgebase/selectors'

class CreateNewSectionContent extends Component {
  
  componentWillReceiveProps(nextProps) {
    const { actions, section, defaultCategoryId } = nextProps
    if (!section.categoryId) actions.changeSectionCategory(defaultCategoryId)
  }
  
  render() {
    const { section, onCloseSidebar, actions, categories, selectedCategoryId, defaultCategoryId } = this.props
    
    if (!categories.length) return null
    
    const categoryId = selectedCategoryId || defaultCategoryId
    const selectedCategory = categories.find(c => c.id === categoryId)
    
    return (
      <div className="category-section-edit-content">
        <div className="category-section-edit-banner">
          <h2 className="category-section-edit-banner-title">Create Section</h2>
        </div>
    
        <div className="category-section-edit-actions">
          <Input
            className="category-section-edit-actions-name-input"
            type="text"
            label="Section Title"
            value={section.name}
            onChange={(e) => actions.changeSectionName(e.target.value)}
          />
          <TextArea
            className="category-section-edit-actions-description-input"
            label="Section Description"
            text={section.description}
            onChange={actions.changeSectionDescription}
          />
          <Select
            clearable={false}
            className="category-section-edit-actions-select"
            label="Display Under Category"
            value={{value: selectedCategory.id, label: selectedCategory.name}}
            onChange={(option) => actions.changeSectionCategory(option.value)}
            options={categories.map(
              category => ({value: category.id, label: category.name}))}
          />
          <div className="category-section-edit-actions-buttons">
            <Button
              disabled={!section.name}
              className="category-section-edit-actions-buttons-save"
              onClick={() => {
                actions.createSection()
                onCloseSidebar()
              }}
            >
              Create Section
            </Button>
            <Button
              className="category-section-edit-actions-buttons-cancel"
              type="secondary"
              onClick={onCloseSidebar}
            >
              Cancel
            </Button>
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = (state, props) => ({
  section: getSectionToEdit(state),
  categories: getCategories(state),
  defaultCategoryId: parseInt(props.match.params.categoryId, 10),
  selectedCategoryId: getSelectedCategoryId(state)
})

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    createSection,
    changeSectionName,
    changeSectionDescription,
    changeSectionCategory
  }, dispatch)
})

export default connect(mapStateToProps, mapDispatchToProps)(CreateNewSectionContent)